<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>REAL-TIME</div>
				<h2 waHeading="l" waText>Bidirectional Client-Server Messaging</h2>
				<p waBody="m" waColorText="quiet" waText>RabbitMQ + WebSocket + Angular &mdash; live updates without boilerplate.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>RabbitMQ WebSocket Bridge</h3>
							<p waBody="m" waColorText="quiet" waText>STOMP over WebSocket connects Angular clients directly to RabbitMQ exchanges. Server publishes via AMQP; browsers receive via STOMP. Automatic reconnection, heartbeat monitoring, and SockJS fallback.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Group-Based Pub/Sub</h3>
							<p waBody="m" waColorText="quiet" waText>Dynamic subscription management with fanout exchanges. Session-aware groups &#40;Everyone, per-session, per-user&#41; with automatic exchange lifecycle.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Angular Directive</h3>
							<p waBody="m" waColorText="quiet" waText>The &#91;data-rabbit-groups&#93; directive subscribes Angular components to RabbitMQ exchanges declaratively. Messages arrive automatically; cleanup runs on destroy.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>STOMP Event Bus</h3>
							<p waBody="m" waColorText="quiet" waText>Built-in receivers for AJAX calls, data requests, data sends, and group management. Inbound messages at /toBus/incoming are deserialized, dispatched, and responded to via the Vert.x event bus.</p>
						</div>
					</wa-card>
				</div>
			</div>
		</div>
	</div>
</div>